module.exports = __webpack_public_path__ + "aec3beac67bb23997dcf27ac46a06637.svg";